(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.ProductWithRatings = (function() {
    function ProductWithRatings() {
      this.getMissingRefugeChemistries = bind(this.getMissingRefugeChemistries, this);
      this.isAValidRefugeOptionFor = bind(this.isAValidRefugeOptionFor, this);
      this.isAValidRefugeOption = bind(this.isAValidRefugeOption, this);
      this.getChemistryTraits = bind(this.getChemistryTraits, this);
      this.updateLength = bind(this.updateLength, this);
      this.hasTrait = bind(this.hasTrait, this);
      this._require_predefined_props = false;
      this.id = null;
      this.seed_company = '';
      this.product_name = '';
      this.trait_package = '';
      this.active = true;
      this.is_placeable = false;
      this.full_name = '';
    }

    ProductWithRatings.prototype.hasTrait = function(prop) {
      return $.isNumeric(this[prop]) && this[prop] > 5;
    };

    ProductWithRatings.prototype.updateLength = function(prop) {
      var length, ref, ref1;
      length = (ref = (ref1 = this[prop]) != null ? ref1.length : void 0) != null ? ref : '';
      if (length === 0) {
        length = '';
      }
      return this[prop + "_length"] = length;
    };

    ProductWithRatings.prototype.getChemistryTraits = function(chemistry_columns) {
      var prop;
      return (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = chemistry_columns.length; i < len; i++) {
          prop = chemistry_columns[i];
          if (this.hasTrait(prop)) {
            results.push(prop);
          }
        }
        return results;
      }).call(this);
    };

    ProductWithRatings.prototype.isAValidRefugeOption = function(refuge_percent_columns) {
      var i, len, prop;
      for (i = 0, len = refuge_percent_columns.length; i < len; i++) {
        prop = refuge_percent_columns[i];
        if (!$.isNumeric(this[prop]) || this[prop] > 0) {
          return false;
        }
      }
      return true;
    };

    ProductWithRatings.prototype.isAValidRefugeOptionFor = function(other, chemistry_columns, refuge_percent_columns) {
      var chem_match, i, len, prop, ref;
      if (!this.is_refuge) {
        return false;
      }
      if (other.active && !this.active) {
        return false;
      }
      if (other.getChemistryTraits(chemistry_columns).length === 0) {
        chem_match = true;
      } else {
        chem_match = false;
        ref = this.getChemistryTraits(chemistry_columns);
        for (i = 0, len = ref.length; i < len; i++) {
          prop = ref[i];
          if (other.hasTrait(prop)) {
            chem_match = true;
            break;
          }
        }
      }
      if (!chem_match) {
        return false;
      }
      return true;
    };

    ProductWithRatings.prototype.getMissingRefugeChemistries = function(refuge_products, chemistry_columns) {
      var i, j, len, len1, missing_traits, product, prop, ref, trait_is_matched;
      missing_traits = [];
      ref = this.getChemistryTraits(chemistry_columns);
      for (i = 0, len = ref.length; i < len; i++) {
        prop = ref[i];
        trait_is_matched = false;
        for (j = 0, len1 = refuge_products.length; j < len1; j++) {
          product = refuge_products[j];
          if (product.hasTrait(prop)) {
            trait_is_matched = true;
            break;
          }
        }
        if (!trait_is_matched) {
          missing_traits.push(prop);
        }
      }
      return missing_traits;
    };

    return ProductWithRatings;

  })();

}).call(this);
